<template>
  <div
    class="about-page page-container page-component pt-3 pb-4 position-relative text-center"
  >
    <div class="px-md-5">
      <div v-html="page.content" class="mb-5 px-md-5"></div>
    </div>
  </div>
</template>
<script>
export default {
  metaInfo: function () {
    return { title: this.$_t("pages:about.meta") };
  },
  i18nOptions: {
    namespaces: "pages",
    keyPrefix: "about",
  },
  components: {},
  data: function () {
    return {
      page: {},
    };
  },
  created: function () {
    this.getData();
  },
  watch: {
    $route: "getData",
  },
  methods: {
    getData: function () {
      this.$http.get("/api/page/about-shas-illuminated").then((response) => {
        this.page = response.data;
      });
    },
  },
};
</script>

<style lang="scss">
.about-page {
  div {
    p {
      text-align: left;
    }
  }
}
</style>
